type QueryLoadingBlockProps = {
  /** Visual density for the page shell. */
  variant?: 'block' | 'cards' | 'rows';
};

/** Pending query shell — use `isPending`, not `isLoading`, so offline pause stays loading. */
export function QueryLoadingBlock({ variant = 'block' }: QueryLoadingBlockProps) {
  if (variant === 'cards') {
    return (
      <div className="grid gap-4 md:grid-cols-2" aria-busy="true">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-40 animate-pulse rounded-xl border border-line bg-panel2" />
        ))}
      </div>
    );
  }

  if (variant === 'rows') {
    return (
      <div className="space-y-2" aria-busy="true">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-12 animate-pulse rounded-lg border border-line bg-panel2" />
        ))}
      </div>
    );
  }

  return (
    <div
      className="h-40 animate-pulse rounded-[14px] border border-line bg-panel"
      aria-busy="true"
    />
  );
}
